export default __webpack_public_path__ + "static/media/save-session.3a408cba.svg";